import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { useGradeTier } from "@/hooks/useGradeTier";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  showText?: boolean;
  collapsed?: boolean;
  clickable?: boolean;
  className?: string;
  variant?: "default" | "white";
}

export default function Logo({
  size = "md",
  showText = true,
  collapsed = false,
  clickable = true,
  className = "",
  variant = "default"
}: LogoProps) {
  const tierProfile = useGradeTier();

  const LogoContent = () => (
    <BrandLogo
      size={size}
      showText={showText && !collapsed}
      variant={variant}
      className={className}
      isKids={tierProfile.isKids}
    />
  );

  if (clickable) {
    return (
      <Link to="/dashboard" className="flex items-center">
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
}